import { render, staticRenderFns } from "./ModuleShippingMain.vue?vue&type=template&id=6f48cf84&scoped=true&"
import script from "./ModuleShippingMain.vue?vue&type=script&lang=js&"
export * from "./ModuleShippingMain.vue?vue&type=script&lang=js&"
import style0 from "./ModuleShippingMain.vue?vue&type=style&index=0&id=6f48cf84&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f48cf84",
  null
  
)

export default component.exports